import { UserThread } from "./user-thread";
import type { MessageThread } from "@agentic_conversation/pages/chat/types";

interface ConversationViewProps {
  threads: MessageThread[];
}

export function ConversationView({ threads }: ConversationViewProps) {
  if (threads.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col space-y-6">
      {threads.map((thread) => (
        <UserThread key={thread.user.id} thread={thread} />
      ))}
    </div>
  );
}
